module.exports = __webpack_public_path__ + "static/media/INDIAVIX.4ea88b1f.txt";